export default function toBoolean(value) {
  return !!value && !['false', '0', ''].includes(`${value}`.toLowerCase());
}
